import { render, staticRenderFns } from "./DrivewealthDocuments.vue?vue&type=template&id=49092a9d"
import script from "./DrivewealthDocuments.vue?vue&type=script&lang=ts"
export * from "./DrivewealthDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports